module.exports = __webpack_public_path__ + "static/img/pic_25.e249615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_25.png
// module id = aNeU
// module chunks = 1